module.exports = __webpack_public_path__ + "static/media/p5detail.6c9e33e0.png";